<template>
  <div class="userprotocol">
    <div id="nav" class="header">
      <head-top></head-top>
    </div>
    <div class="main">
      <div class="protocol">
        <div class="protocol_title">聚师傅用户协议</div>
        <div class="protocol_content">
<p style="margin-top:0;margin-bottom:5px;text-indent:32px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px"><span style="font-family:微软雅黑">聚师傅注重保护用户个人信息及个人隐私，我们会遵循法律规定对您的信息承担保密义务，不会将您的信息透漏给任何第三方。本隐私政策解释了用户（</span>“您”）个人信息收集（以下或称“信息”）和使用的有关情况，本隐私政策适用于聚师傅向您提供的家居服务。如果您不同意本隐私政策的内容，您应立即停止使用聚师傅服务。当您使用聚师傅提供的任一服务时，即表示您已同意我们按照本隐私政策来合法使用和保护您的个人信息。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">一、您个人信息</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:32px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">聚师傅可能掌握的您的个人信息情况如下：</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px"><span style="font-family:微软雅黑">（</span>1）您的个人信息。当您注册聚师傅账户及您在使用相关聚师傅服务时填写、提交或其他任何方式提供的信息，包括您的姓名、性别、出生年月日、身份证号码、电话号码、电子邮箱、收货地址、银行卡信息及相关附加信息（如您地址中的所在的省份和城市、邮政编码等）。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px"><span style="font-family:微软雅黑">（</span>2）您的设备信息。聚师傅可能会读取您访问聚师傅或使用聚师傅服务时所使用的终端设备的信息，包括但不限于设备型号、设备识别码、操作系统、分辨率、电信运营商等。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px"><span style="font-family:微软雅黑">（</span>3）您的行为。聚师傅可能会记录您使用聚师傅服务时所进行的操作。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">除上述信息外，我们还可能为了提供服务及改进服务质量的合理需要而获得的您的其他信息，包括您与我们的客服团队联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您聚师傅合作伙伴之间互动时我们获得的相关信息。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">二、聚师傅对您个人信息的管理和使用</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">为向您提供服务、提升我们的服务质量以及优化您的服务体验，我们会在符合法律规定下使用您的个人信息，向您提供您使用的各项服务，并维护、改进这些服务。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">三、您个人信息的分享</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:32px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">您的个人信息是我们为您提供服务的重要部分，我们会遵循法律规定对您的信息承担保密义务。除以下情形外，我们不会将您的个人信息披露给第三方：</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">1、征得您的同意或授权。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">2、根据法律法规的规定或行政或司法机构的要求。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">3、您出现违反中国有关法律、法规规定或者违反您与聚师傅签署的相关协议（包括在线签署的电子协议）或违反相关聚师傅平台规则时需要向第三方披露的情形。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">四、您个人信息的安全</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">聚师傅严格保护您的个人信息安全。我们使用各种制度、安全技术和程序等措施来保护您的个人信息不被未经授权的访问、篡改、披露或破坏。如果您对我们的个人信息保护有任何疑问，请联系我们的客服。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">在使用聚师傅网服务时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者地址等。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的账户及密码发生泄露，请您立即联络我们的客服，以便我们采取相应措施。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">五、未成年人的个人信息保护</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px"><span style="font-family:微软雅黑">聚师傅非常重视对未成年人个人信息的保护。若您是</span>18周岁以下的未成年人，在使用聚师傅服务前，应事先取得您家长或法定监护人的书面同意。聚师傅根据国家相关法律法规的规定保护未成年人的个人信息。</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">六、通知和修订</span>
</p>
<p style="margin-top:0;margin-bottom:5px;text-indent:13px;vertical-align:baseline">
    <span style=";font-family:微软雅黑;color:rgb(49,49,49);font-size:16px">为给你提供更好的服务，聚师傅的业务将不时变化，本隐私政策也将随之调整。聚师傅会通过在聚师傅网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问聚师傅以便即时了解最新的隐私政策。如果您对于本隐私政策或在使用聚师傅服务时对于您的个人信息或隐私情况有任何问题，请联系聚师傅客服并作充分描述，聚师傅将尽力解决。</span>
</p>
<p>
    <br/>
</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from "./../../components/headTop";
export default {
  components: {
    headTop
  },
  data() {
    return {};
  },
  mounted() {
    var _this = this;
  },

  methods: {}
};
</script>
<style lang='scss' scoped>
.userprotocol {
  background: #eef0f3;
  .headDefault {
    background: #3455d3;
  }
  .main {
    padding: 40px 0 30px 0;
    .protocol {
      background: #ffffff;
      width: 1200px;
      padding: 30px;
      margin: 0 auto;
      padding-bottom: 30px;
      .protocol_title{
        color: #2F3133;
        font-size: 32px;
        text-align: center;
      }
      .protocol_content{
        font-size: 14px;
        color: #2F3133;
        margin-top: 30px;
      }
    }
  }
}
</style>